// NUMBERセルの maxLength は、機能プロパティの max_length と同じく文字数ではなく
// 桁数として扱う。1日あたりの作業時間 7.5 のような小数を許容するため、数えるのは
// 整数部の桁数のみ。
export const exceedsMaxDigits = (
  value: unknown,
  maxDigits: number | undefined
): boolean => {
  if (maxDigits === undefined) return false
  if (typeof value !== 'number' || !Number.isFinite(value)) return false
  return Math.floor(Math.abs(value)).toString().length > maxDigits
}
